import ProxiedImage from '@modules/common/components/proxied-image';

import type { MediaUploadElementNode } from './types';

export const MediaUpload = ({ value }: MediaUploadElementNode) => {
  if (!value?.url) {
    console.warn('[MediaUpload] Missing media URL - node will not render', {
      value,
    });
    return null;
  }

  return (
    <div className="mt-2 flex justify-center">
      <ProxiedImage
        url={value.url}
        alt={value.alt ?? ''}
        label="RichContent"
        width={value.width}
        height={value.height}
        className="overflow-hidden rounded-md"
        loading="lazy"
        fallback={
          <div className="flex h-32 w-full max-w-md items-center justify-center rounded-md bg-gray-100 text-sm text-gray-400">
            圖片載入失敗
          </div>
        }
      />
    </div>
  );
};
